module.exports = __webpack_public_path__ + "static/media/middle.ac0a2e77.svg";